module.exports = __webpack_public_path__ + "img/kasprowicz.723bfa2f.jpg";